'use strict';

import angular from 'angular';
import ngRoute from 'angular-route';

import {DescargasRouteComponent} from './descargas-route.component';
import {EditarDescargasComponent} from './editar/editar-descargas.component';
import {CrearDescargasComponent} from './crear/crear-descargas.component';
import DescargasService from './descargas.service';

/*@ngInject*/
const routes = function ($routeProvider) {
    $routeProvider.when('/descargas', {
            template: '<descargas-route descargas="$resolve.descargas.data"></descargas-route>',
            authenticate: true,
            resolve: {
                descargas: getDescargas
            }

        })
        .when('/descargas/crear', {
            template: '<crear-descargas></crear-descargas>',
            authenticate: true,
            administrator: true
        })
        .when('/descargas/editar', {
            template: '<editar-descargas descargas="$resolve.descargas.data"></editar-descargas>',
            authenticate: true,
            administrator: true,
            resolve: {
                descargas: getDescargas
            }
        });

    function getDescargas(DescargasService) {
        return DescargasService.getDescargas();
    }
};

export default angular.module('pizzutoAutopartesApp.descargas', [ngRoute])
    .config(routes)
    .component(DescargasRouteComponent.selector, DescargasRouteComponent)
    .component(EditarDescargasComponent.selector, EditarDescargasComponent)
    .component(CrearDescargasComponent.selector, CrearDescargasComponent)
    .service('DescargasService', DescargasService)
    .name;



// WEBPACK FOOTER //
// ./client/app/descargas-route/index.js